import { defineStore } from 'pinia'
import type { DynamicComponent, SnackBanner } from '@/types'

const initDynamicComponent = (): DynamicComponent => ({
  value: false,
  component: undefined,
  data: {},
  events: {},
  animation: 'fade',
})

const initialSnackBanner: SnackBanner[] = []

export const useUIStore = defineStore('ui', () => {
  const dynamicSidePanel = ref<DynamicComponent>(initDynamicComponent())
  const dynamicPopup = ref<DynamicComponent>(initDynamicComponent())
  const snackBanners = ref<SnackBanner[]>([...initialSnackBanner])

  const showSidePanel = (
    component: DynamicComponent['component'],
    data: object = {},
    events: object = {},
    animation = 'fade'
  ) => {
    dynamicSidePanel.value = {
      value: true,
      component: markRaw(component!),
      data,
      events,
      animation,
    }
  }

  const showPopup = (component: DynamicComponent['component'], data: object = {}, events: object = {}) => {
    if (!component) {
      console.warn('showPopup called with undefined component')
      return
    }
    dynamicPopup.value = {
      value: true,
      component: markRaw(component),
      data: data || {},
      events: events || {},
    }
  }

  const showSnackBanner = (type: SnackBanner['type'], text: string) => {
    snackBanners.value.push({
      id: Date.now(),
      type,
      text: text || (type === 'success' ? 'Success' : 'Something went wrong'),
    })
  }

  const resetSnackBanner = (id: number) => {
    snackBanners.value = snackBanners.value.filter((item) => item.id !== id)
  }

  const cleanSidePanel = () => {
    dynamicSidePanel.value = initDynamicComponent()
  }

  const cleanPopup = () => {
    dynamicPopup.value = initDynamicComponent()
  }

  const getDynamicSidePanel = computed(() => dynamicSidePanel.value)
  const getDynamicPopup = computed(() => dynamicPopup.value)

  return {
    dynamicSidePanel,
    dynamicPopup,
    snackBanners,
    showSidePanel,
    showPopup,
    cleanSidePanel,
    getDynamicSidePanel,
    showSnackBanner,
    resetSnackBanner,
    cleanPopup,
    getDynamicPopup,
  }
})
